<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:20px;">
      <div class="title-font-style">
        <span>收款信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款编号：">{{ bankformList.receiptNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款方式：">
              银行转账
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款类型：">销售货款</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款人名称：">{{bankformList.receiptName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款银行账号：">{{bankformList.receiptBankNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行名称：">{{bankformList.receiptOpenBank}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款金额：">{{bankformList.receiptMoney | toFixed}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交易流水号：">{{bankformList.flowCode}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交易时间：">{{bankformList.tradeDate | dateFilter}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：">{{bankformList.mark}}</el-form-item>
          </el-col>
        </el-row>
<!--        <el-row :gutter="20">-->
<!--          <el-col :span="20">-->
<!--            <el-form-item label="备注：">{{bankformList.confirmMark}}</el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
    </div>

    <div class="item-box-content">
      <div class="title-font-style">
        <span>付款账户</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="bankformList">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="账户名称：">{{bankformList.payName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款银行账户：">{{bankformList.payBankNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行名称：">{{bankformList.payOpenBank}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行行号：">{{bankformList.payBankCode}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" v-show="bankformList.confirmState === 1">
      <div class="title-font-style">
        <span>审核</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="bankformList">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="审核结果：">审核不通过</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注：">{{bankformList.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <operation-log-and-flow :flowLabel="flowLabel" :id="id"></operation-log-and-flow>
  </div>
</template>
<script>
import { queryByFbrId } from '@/api/fiance/fianceManage'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow'
import { formatData } from '@/util/filterCommon'
export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      dialogVisible: false,
      flowLabel: '签署流程',
      id: this.$route.query.fprsId,
      value: '',
      reverse: true,
      bankformList: {},
      params: {},
      textarea: '',
      radio: '',
      orderContractStockup: {},
      waitList: [], // 待配货清单
      orderContractStockupStorageVoList: [{}], // 仓库备货区
      orderContractStockupPurchaseVoList: [],
      activeName: '合并计划', // 采购备货区tabs选中状态
      procurementPlanList: [{}], // 采购计划
      purchasingStockAreaTable: [{}]
    }
  },

  mounted () {
    queryByFbrId(this.$route.query.fprsId)
      .then((res) => {
        if (res.data.code === 200) {
          this.bankformList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    formatData,
    // 搜索
    onSearch () {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }

      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
      }
    },
    aross () {},
    lose () {},
    // 提交
    open () {},

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.pay {
  padding-top: 8px;
  font-weight: bold;
}
</style>
